import React from 'react';
import { Widget, usePromise, Table, Button, useRouter } from '@digital/ui';
import { currencyFormat } from '@app/helpers/numbers';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getAllPendencias, Pendencia, aprovarTodasPendencias } from '@app/api/boletimMedicao';
import { useRecoilValue } from 'recoil';
import { medicaoSelectedState } from '../atoms';

const columns = [
  {
    title: 'Itens do Contrato (Todos os níveis da PQ)',
    className: 'item-contrato-coluna',
    children: [
      {
        title: 'Item',
        dataIndex: 'item',
        key: 'item',
        className: 'item-contrato-coluna',
      },
      {
        title: 'Descrição',
        dataIndex: 'descricao',
        key: 'descricao',
        className: 'item-contrato-coluna',
      },
      {
        title: 'Unidade',
        dataIndex: 'unidade',
        key: 'unidade',
        className: 'item-contrato-coluna',
      },
      {
        title: 'Quantidade',
        dataIndex: 'quantidade',
        key: 'quantidade',
        className: 'item-contrato-coluna',
      },
      {
        title: 'Preço',
        dataIndex: 'preco',
        key: 'preco',
        className: 'item-contrato-coluna',
        render: currencyFormat,
      },
      {
        title: 'Verba Total',
        dataIndex: 'verbaTotal',
        key: 'verbaTotal',
        className: 'item-contrato-coluna',
        render: currencyFormat,
      },
    ],
  },
  {
    title: 'Quantidades do Boletim de Medição',
    className: 'quantidade-boletim-medicao-coluna',
    children: [
      {
        title: 'Anterior',
        dataIndex: 'quantidadeAnterior',
        key: 'quantidadeAnterior',
        className: 'quantidade-boletim-medicao-coluna',
      },

      {
        title: 'Período',
        dataIndex: 'quantidadePeriodo',
        key: 'quantidadePeriodo',
        className: 'quantidade-boletim-medicao-coluna',
      },
      {
        title: 'Acumulado',
        dataIndex: 'quantidadeAcumulado',
        key: 'quantidadeAcumulado',
        className: 'quantidade-boletim-medicao-coluna',
      },
      {
        title: 'Saldo',
        dataIndex: 'quantidadeSaldo',
        key: 'quantidadeSaldo',
        className: 'quantidade-boletim-medicao-coluna',
      },
    ],
  },
];

interface MedicaoFormProps {
  onRemoveAba: () => any;
}

const AbaPendencias = (props: MedicaoFormProps) => {
  const { onRemoveAba } = props;
  const medicaoSelected = useRecoilValue(medicaoSelectedState);
  const { history } = useRouter();

  const [pendencias] = usePromise(
    () => (medicaoSelected ? getAllPendencias(medicaoSelected.id) : Promise.resolve(undefined)),
    [medicaoSelected],
    [] as Pendencia[],
  );

  const handleCancel = () => {
    onRemoveAba();
    history.push(`/boletimDeMedicoes/detail/${medicaoSelected.id}/medicao`);
  };
  const handleApproveAll = () =>
    aprovarTodasPendencias(medicaoSelected.id).then(_ => {
      handleCancel();
    });

  return (
    <>
      <Widget
      id={'widgetPendencias'}
        actions={[
          <Button type="link" onClick={handleCancel}>
            Cancelar
          </Button>,
          <Button type="success" onClick={handleApproveAll}>
            Aprovar Linhas Sem Lançamento
          </Button>,
        ]}
        title="Linhas do BM não lançadas">
        <PerfectScrollbar>
          <Table columns={columns} dataSource={pendencias} pagination={false} style={{ overflowY: 'auto' }} />
        </PerfectScrollbar>
      </Widget>
    </>
  );
};

export default AbaPendencias;
